<script>
  import LinkComponent from "$lib/contentTypes/LinkComponent.svelte";
  import NavTarget from "$lib/contentTypes/NavTarget.svelte";

  export let data;
  let clazz = "";
  export { clazz as class };

  const COMPONENT_MAP = {
    linkComponent: LinkComponent,
    navigationTarget: NavTarget
  };
</script>

<ul class="lg:mx-20 h-full flex flex-col lg:flex-row {clazz}">
  {#if data.children}
    {#each data.children as child}
      <li
        class="relative lg:flex flex-col lg:justify-center lg:items-center"
        aria-current={child.active}
      >
        <svelte:component this={COMPONENT_MAP[child.contentType]} data={child} />

        <!-- active product indicator -->
        {#if child.active}
          <span
            class="absolute text-white bg-white px-10 rotate-45 rounded-2 mt-72 hidden lg:block not-sr-only"
            >&nbsp;</span
          >
        {/if}
      </li>
    {/each}
  {/if}
</ul>
